export function initFullWidthSwiper() {
    const swipers = document.querySelectorAll<HTMLElement>('.swiper-full');

    swipers.forEach(swiper => {
        const container = swiper.closest<HTMLElement>('.container');
        const sidebar = document.querySelector<HTMLElement>('.main-sidebar');

        if (!container) return;

        function updateWidth() {
            const containerRect = container.getBoundingClientRect();
            let leftOffset: number;

            if (sidebar) {
                const sidebarRect = sidebar.getBoundingClientRect();
                // offset от левой границы вьюпорта до правого края сайдбара
                leftOffset = sidebarRect.right + window.scrollX;
            } else {
                // если сайдбара нет — берём левую границу контейнера
                leftOffset = containerRect.left + window.scrollX;
            }

            const viewportWidth = document.documentElement.clientWidth;
            const newWidth = viewportWidth - leftOffset - 60;
            swiper.style.width = `${newWidth}px`;
        }

        // вызвать при загрузке
        updateWidth();
        // пересчёт при ресайзе
        window.addEventListener('resize', updateWidth);
    });
}
